import Select from "react-select";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {tryFetchProvinces} from "../../redux/slices/addressSlice";

export const ProvinceSelector = ({
                                   province,
                                   className = "",
                                   setProvince,
                                   editPopup,
                                   disabled,
                                   error,
                                   preserveErrorSpace=true
                                 }) => {

  const {data: provinces, loading, init} = useSelector((state) => state.address.provinces)

  const dispatch = useDispatch();

  useEffect(() => {
    if (!init) {
      dispatch(tryFetchProvinces())
    }

  }, [init])

  return (
    <div className={className}>
      <label className="ml-3">Province *</label>
      <Select instanceId="province" placeholder="Select Province"
        isLoading={loading}
        value={province}
        options={provinces}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        isDisabled={disabled}
        onChange={(option) => {
          setProvince(option);
        }}
        // styles={addressCustomStyle}
        />
        {
          (error) ? <div
              className='text-xs text-error-500 ml-4 pt-2'>{error}</div> :
            (preserveErrorSpace ? <div className="h-[5px]"/> : "")
        }
    </div>
)
}

export const addressCustomStyle = {
    control: (base) => ({
      ...base,
      border: '1px solid #bdbfbe',
      borderRadius: '32px',
      padding: '1px',
      ':hover': {
        ...base[':hover'],
        borderColor: '#4fe2c0',
        boxShadow: 'none'
      },
    })
  }
